/* 🤖 this file was generated by svg-to-ts */
export const sbIconsMegaphone: {
  name: 'megaphone';
  data: string;
} = {
  name: 'megaphone',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19.99121 2.002a.99943.99943 0 0 0-1 1v.63672a9.0362 9.0362 0 0 1-7 3.36328h-6a3.0033 3.0033 0 0 0-3 3v2a3.0033 3.0033 0 0 0 3 3H6.475l-2.40273 5.6064a.9993.9993 0 0 0 .91894 1.3936h4a.9986.9986 0 0 0 .91895-.60644L12.63391 15.04a9.028 9.028 0 0 1 6.3573 3.32507v.63693a1 1 0 0 0 2 0v-16a.9994.9994 0 0 0-1-1m-14 11a1.00067 1.00067 0 0 1-1-1v-2a1.0007 1.0007 0 0 1 1-1h1v4Zm2.34082 7H6.50781l2.14258-5h1.82422Zm10.65918-4.4782a11.052 11.052 0 0 0-7-2.52185h-3v-4h3a11.0528 11.0528 0 0 0 7-2.52234Z"/></svg>`
};
